import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { IRouter } from '../../interfaces/router.interface';
import { IIcon } from '../icon/icon.interface';
import { IconSizesEnum } from '../icon/icons-sizes.enum';
import {
  I2gNgTrackingActionBuilder,
  ITrackingAction,
  ITrackingObject,
} from 'i2g-ng-tracking';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';

@Component({
  selector: 'app-overview-metric',
  templateUrl: './overview-metric.component.html',
  styleUrls: ['./overview-metric.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverviewMetricComponent implements OnInit {
  @Input() type: string;
  @Input() label: string;
  @Input() data: string;
  @Input() cta: IRouter;
  @Input() miniSize: boolean;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  @HostBinding('class.mini-metric')
  get miniMetricComponentCSSClass(): boolean {
    return this.miniSize;
  }

  smallLoadingIcon: IIcon;
  mediumLoadingIcon: IIcon;
  largeLoadingIcon: IIcon;

  trackingAction: ITrackingAction;

  constructor(private _trackingActionBuilder: I2gNgTrackingActionBuilder) {}

  ngOnInit() {
    const iconName = 'loading-spinner';

    this.smallLoadingIcon = {
      name: iconName,
      size: IconSizesEnum.small,
    };
    this.mediumLoadingIcon = {
      name: iconName,
      size: IconSizesEnum.medium,
    };
    this.largeLoadingIcon = {
      name: iconName,
      size: IconSizesEnum.large,
    };

    this.trackingAction = this._trackingActionBuilder.buildButtonTapped(
      `total_${this.type}`,
      this.trackingScreenName
    );
  }
}
